import { AllPalletsResponseModel, CommonResponse, CreatePalletsResponseModel, PalletAckResponse, PalletResponse, PalletsResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { PalletByIdDto } from './dto/pallet-by-id-req';
import { PalletUpdateDTO } from './dto/pallet-update.dto';
import { PalletDTO } from './dto/pallet.dto';
import { PalletRequest } from './dto/pallet.request';
import { PalletsDTO } from './dto/pallets.dto';
import { PalletsDtoActive } from './dto/pallet_dto_active';
import { PlantPalletRequest } from './dto/plant-pallet.request';
import { PalletsService } from './pallets.service';

@ApiTags('pallets')
@Controller('pallets')
export class PalletsController {
  constructor(private palletsService: PalletsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }


  @Post('/createpallets')
  async createPallets(@Body() palletsDto: PalletsDTO): Promise<CreatePalletsResponseModel>  {
    try {
      return await this.palletsService.CreatePallets(palletsDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CreatePalletsResponseModel, error);
    }
  }


  @Post('/updatePallets')
  async updatePallets(@Body() palletsDto: PalletsDTO): Promise<CreatePalletsResponseModel>  {
    try {
      return await this.palletsService.CreatePallets(palletsDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CreatePalletsResponseModel, error);
    }
  }


  @Post('getRecordByPalletsId')
  async getRecordByPalletsId(@Body() id: PalletByIdDto): Promise<PalletsResponseModel> {
    try {
      return await this.palletsService.getRecordByPalletsId(id.palletId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletsResponseModel, error);
    }
  }

  @Post('activateorDeactivatePallet')
  async activateorDeactivatePallet(@Body() palletAct: PalletsDtoActive):Promise<PalletResponse> {
    try {
      return await this.palletsService.activateorDeactivatePallet(palletAct);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletResponse, error);
    }
  }
  @Post('getPalletById')
  async getPalletById(@Body() palletRequest: PalletRequest):Promise<PalletsResponseModel> {
    try {
      return await this.palletsService.getPalletById(palletRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletsResponseModel, error);
    }
  }

  // New services as per navtech requirement. Wooden configuration service

  /**
   * calling a service to create a new pallet
   * @param palletDto 
   * @returns 
   */
  @Post('/createPallet')
  async createPallet(@Body() palletDto: PalletDTO): Promise<PalletAckResponse>  {
    try {
      return await this.palletsService.createPallet(palletDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletAckResponse, error);
    }
  }

  /**
   * calling a service to update a existing pallet
   * @param palletDto 
   * @returns 
   */
  @Post('/updatePallet')
  async updatePallet(@Body() palletDto: PalletUpdateDTO): Promise<PalletAckResponse>  {
    try {
      return await this.palletsService.updatePallet(palletDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletAckResponse, error);
    }
  }

  /**
   * calling a service to get all pallets
   * @returns 
   */
  @Post('getAllPallets')
  async getAllPallets(@Body() req:PlantIdRequest):Promise<PalletAckResponse> {
    try {
      return await this.palletsService.getAllPallets(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PalletAckResponse, error);
    }
  }

  /**
   * calling a service to dimensions list by plant id
   * @param plantIdReq
   * @returns 
   */
  @Post('getPalletsByPlantId')
  async getPalletsByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<PalletAckResponse> {
      try {
          return await this.palletsService.getPalletsByPlantId(plantIdReq);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(PalletAckResponse, error);
      }
  }

  /**
   * calling a service to validate pallet
   * @param plantPalletIdReq
   * @returns 
   */
   @Post('isPalletRegistered')
   async isPalletRegistered(@Body() plantPalletIdReq: PlantPalletRequest):Promise<PalletAckResponse> {
       try {
           return await this.palletsService.isPalletRegistered(plantPalletIdReq);
       } catch (error) {
           return this.applicationExceptionHandler.returnException(PalletAckResponse, error);
       }
   }

   /**
   * calling a service to validate pallet
   * @param plantPalletIdReq
   * @returns 
   */
    @Post('getEpcForPallet')
    async getEpcForPallet(@Body() plantPalletIdReq: PlantPalletRequest):Promise<CommonResponse> {
        try {
            return await this.palletsService.getEpcForPallet(plantPalletIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getPalletByPalletNo')
    async getPalletByPalletNo(@Body() palletRequest: PlantPalletRequest): Promise<CommonResponse> {
        try {
            return await this.palletsService.getPalletByPalletNo(palletRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}
